import { Row } from "@tanstack/react-table";

import { CustomLink } from "ui/custom-link";

import { getBatchPath } from "utilities/app-routes";

import { TouchpointVersionHistoryDto } from "generated/schemas";

interface BatchTableRowProps {
  row: Row<TouchpointVersionHistoryDto>;
}

const BatchTableRow = ({ row }: BatchTableRowProps) => {
  const groupingCol = row.groupingColumnId as string | undefined;
  const rawBatchId = groupingCol
    ? (row.getGroupingValue(groupingCol) as string | null | undefined)
    : undefined;
  const isInBatch = rawBatchId != null && rawBatchId !== "";

  const batchName = row.original.touchpointBatchName;

  const batchDetailsPath =
    isInBatch && rawBatchId ? getBatchPath({ batchId: rawBatchId, isClientUser: true }) : "";

  return (
    <div className="flex items-center w-full min-w-0">
      <div className="flex items-center gap-2 min-w-0">
        {isInBatch ? (
          <CustomLink
            to={batchDetailsPath}
            className="truncate"
            label={batchName || "Batch"}
          />
        ) : (
          <span className="text-gray-600">Not in a batch</span>
        )}
      </div>
    </div>
  );
};

export default BatchTableRow;
